<template>
	<div class="w-full mainCartas">
		<h1>{{$t('Carta')}}</h1>

		<div class="my-5">
			<div>
				<hotelDropdown v-show="user.role != 4" v-bind:append_to_body="false" v-bind:current_stay="hotel_id" v-on:onChangeHotel="onChangeHotel" v-on:createMenu="create_new_menu()" :menus_page="true"></hotelDropdown>
			</div>

			<div v-if="user.role == 4">
				<div class="flex flex-wrap">
					<h3 class="mt-2">{{ user.staff_info.hvg_desc }}</h3>
					<vs-button class="ml-5 -py-5" color="primary" v-on:click="create_new_menu()">{{$t('newo')}}</vs-button>
				</div>
			</div>
		</div>

		<div v-if="create_new == true">
			<small class="block">{{$t('Tipo')}}</small>
			<v-select class="sm:w-full lg:w-1/4 vue-select" :clearable="false" :searchable="false" v-model="type_selected" :options="menu_types">
		</v-select>
		</div>

		<vs-row v-if="type_selected && hotel_id">
			<div class="w-full">
				<vs-button class="float-right lg:mt-0 mt-4" color="primary" type="filled" v-on:click="exit_edit_mode()">{{$t('returnButton')}}</vs-button>
			</div>
		</vs-row>

		<vx-card class="mt-5" v-if="type_selected && hotel_id">
			<CartaForm v-if="type_selected == 'Carta'" :hotel_id="hotel_id" :type_selected="type_selected" :warehouses="warehouses" :menu="menu" v-on:edit-finished="exit_edit_mode()" v-on:hideType="hideTypeField()" />

			<MenuForm v-if="type_selected == 'Menu'" :hotel_id="hotel_id" :type_selected="type_selected" :warehouses="warehouses" :menu="menu" v-on:edit-finished="exit_edit_mode()" v-on:hideType="hideTypeField()" />

			<DirectorioForm v-if="type_selected == 'Directório'" :hotel_id="hotel_id" :type_selected="type_selected" :menu="menu" v-on:edit-finished="exit_edit_mode()" v-on:hideType="hideTypeField()" />

			<MarcacaoForm v-if="type_selected == 'Marcação'" :hotel_id="hotel_id" :type_selected="type_selected" :menu="menu" v-on:edit-finished="exit_edit_mode()" v-on:hideType="hideTypeField()" />
		</vx-card>

		<vx-card v-if="hotel_id != '' && menus.length == 0 && create_new == false" class="mt-5">
			<div>
				<p align="center">{{$t('Não_foram_encontradas_cartas_para_o_hotel_selecionado')}}</p>
			</div>
		</vx-card>

		<div v-if="update == false && create_new == false && hotel_id && menus.length > 0" class="w-full">

			<vx-card>
				<div class="flex flex-wrap">
					<div class="sm:w-full w-full lg:w-1/2 px-1">
						<h3 class="text-center">{{$t('Carta')}}</h3>
						<vs-list class="w-full mt-2">
							<vs-list-item class="w-full" v-for="(m, index) in cartas_grouped_by_type['Carta']" :key="index" :title="m.idiomas[0].menu_id+ '. ' +m.idiomas[0].name">
								<vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" v-on:click="enter_edit_mode(m)"></vs-button>
								<vs-button class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" v-on:click="openDialog(m, 'carta')"></vs-button>
								<vs-button class="ml-2" color="warning" type="filled" icon-pack="feather" icon="icon-copy" v-on:click="openPopup(m)"></vs-button>
							</vs-list-item>
						</vs-list>
					</div>

					<div class="sm:w-full w-full lg:w-1/2 px-1">
						<h3 class="text-center">{{$t('Menu')}}</h3>
						<vs-list class="w-full mt-2">
							<vs-list-item class="w-full" v-for="(m, index) in cartas_grouped_by_type['Menu']" :key="index" :title="m.idiomas[0].menu_id+ '. ' +m.idiomas[0].name">
								<vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" v-on:click="enter_edit_mode(m)"></vs-button>
								<vs-button class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" v-on:click="openDialog(m, 'menu')"></vs-button>
								<vs-button class="ml-2" color="warning" type="filled" icon-pack="feather" icon="icon-copy" v-on:click="openPopup(m)"></vs-button>
							</vs-list-item>
						</vs-list>
					</div>
				</div>
				<div class="flex flex-wrap mt-8">
					<div class="sm:w-full w-full lg:w-1/2 px-1">
						<h3 class="text-center">{{$t('Directório')}}</h3>
						<vs-list class="w-full mt-2">
							<vs-list-item class="w-full" v-for="(m, index) in cartas_grouped_by_type['Directório']" :key="index" :title="m.idiomas[0].menu_id+ '. ' +m.idiomas[0].name">
								<vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" v-on:click="enter_edit_mode(m)"></vs-button>
								<vs-button class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" v-on:click="openDialog(m, 'directório')"></vs-button>
							</vs-list-item>
						</vs-list>
					</div>

					<div class="sm:w-full w-full lg:w-1/2 px-1">
						<h3 class="text-center">{{$t('Marcação')}}</h3>
						<vs-list class="w-full mt-2">
							<vs-list-item class="w-full" v-for="(m, index) in cartas_grouped_by_type['Marcação']" :key="index" :title="m.idiomas[0].name">
								<vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" v-on:click="enter_edit_mode(m)"></vs-button>
								<vs-button class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" v-on:click="openDialog(m, 'marcação')"></vs-button>
							</vs-list-item>
						</vs-list>
					</div>

				</div>
			</vx-card>
		</div>

		<vs-popup fullscreen class="copy_pop_up" :title="name_copy_pop_up" :active.sync="copy_pop_up">
		    <div class="w-full">

		    	<small class="block">{{$t('hotel')}}</small>
				<v-select 
				class="vue-select sm:w-full select-hotel" 
				v-model="hoteis_to_copy" 
				:options="hotel_list" 
				label="name"
				:multiple="true">
				</v-select>

				<small class="block mt-5">{{$t('Capitulo ')}}</small>

				<vs-divider color="#63C0BB">PT</vs-divider>
				<v-select class="vue-select sm:w-full" :multiple="true" v-model="langs['PT']" :options="chapters_langs['PT']" label="name" :placeholder="'Todos'">
					<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
				</v-select>

				<vs-divider color="#63C0BB">BR</vs-divider>
				<v-select class="vue-select sm:w-full" :multiple="true" v-model="langs['BR']" :options="chapters_langs['BR']" label="name" :placeholder="'Todos'">
					<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
				</v-select>

				<vs-divider color="#63C0BB">EN</vs-divider>
				<v-select class="vue-select sm:w-full" :multiple="true" v-model="langs['EN']" :options="chapters_langs['EN']" label="name" :placeholder="'Todos'">
					<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
				</v-select>

				<vs-divider color="#63C0BB">FR</vs-divider>
				<v-select class="vue-select sm:w-full" :multiple="true" v-model="langs['FR']" :options="chapters_langs['FR']" label="name" :placeholder="'Todos'">
					<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
				</v-select>

				<vs-divider color="#63C0BB">DE</vs-divider>
				<v-select class="vue-select sm:w-full" :multiple="true" v-model="langs['DE']" :options="chapters_langs['DE']" label="name" :placeholder="'Todos'">
					<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
				</v-select>

				<vs-divider color="#63C0BB">ES</vs-divider>
				<v-select class="vue-select sm:w-full" :multiple="true" v-model="langs['ES']" :options="chapters_langs['ES']" label="name" :placeholder="'Todos'">
					<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
				</v-select>

		    </div>
		    <div class="text-center mt-5">
		      	<vs-button :disabled="hoteis_to_copy.length == 0" class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="success" type="filled" v-on:click="save_copy()">{{$t('Gravar')}}</vs-button>
				<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="danger" type="filled" v-on:click="copy_pop_up=false">{{$t('sair')}}</vs-button>
		    </div>
		</vs-popup>

	</div>
</template>

<script>

//load hotel dropdown from components
import HotelDropdown from '@/views/components/HotelDropdown.vue';

import MenuForm from '../components/MenuForm';
import CartaForm from '../components/CartaForm';
import MarcacaoForm from '../components/MarcacaoForm';
import DirectorioForm from '../components/DirectorioForm';

export default {
  	data() {
		return {
			hotel_id: '',
			warehouse_id: '',
			inputs: [],
			warehouses: [],
			name: '',
			menu_types: ['Menu', 'Carta', 'Directório', 'Marcação'],
			menu_type: ['Menu'],
			moedas: ['Euro', 'Real', 'Dollar'],
			type_selected: '',
			coin_selected: '',
			information: '',
			description: '',
			price: '',
			files: {
				thumbnail_files: []
			},
			chapter: '',
			user: JSON.parse(window.localStorage.getItem('userSession')),
			create_new: false,
			menus: [],
			menu: '',
			update: false,
			copy_pop_up: false,
			hotel_list: [],
			chapters_langs: {
                PT: [],
                BR: [],
                EN: [],
                FR: [],
                DE: [],
                ES: []
            },
			name_copy_pop_up: null,
			id_copy_pop_up: null,
			hoteis_to_copy: [],
			langs: {
                PT: [],
                BR: [],
                EN: [],
                FR: [],
                DE: [],
                ES: []
            },
		}
  	},

  	methods: {
  		openPopup(menu){
  			this.getHotels();
  			this.chapters_langs = {
                PT: [],
                BR: [],
                EN: [],
                FR: [],
                DE: [],
                ES: []
            }
  			let array_idiomas = [];
  			for (let i = 0; i < menu.idiomas.length; i++) {
  				array_idiomas.push(menu.idiomas[i].id);
  			}
  			this.getChaptersAllLangs(array_idiomas);
  			this.name_copy_pop_up = menu.idiomas[0].name;
  			this.id_copy_pop_up = menu.id;
  			this.copy_pop_up = true;
  		},
  		getChaptersAllLangs(idiomas){
  			this.$vs.loading();
  			let that = this;
			this.$api({
				method: 'get',
				url: '/myvilagale/hotel/menu/chapters',
				params: {
					token: this.$user.usertoken,
					langs: idiomas
				}
			}).then(function (res) {
				let result = res.data;

				for (let i = 0; i < result.length; i++) {
					that.chapters_langs[result[i].idioma.language].push(result[i]);
				}

			}).catch ( function (err) {
				that.notify(that.$t('Erro_nos_subcapitulos'), 'red');
			}).then(function (res) {
				that.$vs.loading.close();
			});
  		},
  		save_copy(){
  			this.$vs.loading();

  			let hoteis_to_save = [];
  			for (let i = 0; i < this.hoteis_to_copy.length; i++) {
				hoteis_to_save.push(this.hoteis_to_copy[i].id);
  			}

  			let chapters_to_save = [];
			Object.entries(this.langs).forEach(
			    ([key, value]) => {
			    	for (let i = 0; i < value.length; i++) {
						chapters_to_save.push(value[i].id);
					}
			    }
			);

  			let that = this;
			this.$api({
				method: 'post',
				url: '/myvilagale/menu/copy',
				data: {
					token: this.$user.usertoken,
					hoteis: hoteis_to_save,
					chapters: chapters_to_save,
					menu_id: this.id_copy_pop_up,
				}
			})
			.then(function (res) {
  				that.copy_pop_up = false;
  				that.notify(that.$t('Carta_copiada_com_sucesso'), 'green');
  				that.notify(that.$t('atualize_armazem'), 'primary', 10);
			})
			.catch ( function (err) {
				that.notify(that.$t('Erro_a_gravar'), 'red');
			})
			.then(function (res) {
				that.$vs.loading.close();
			});
  		},
	    hideTypeField() {
		    this.create_new = false;
		    this.exit_edit_mode();
	    },
		onChangeHotel(newHotel) {
			this.hotel_id = newHotel;
			this.getWarehouses(this.hotel_id);
			this.getMenusWihtLanguages(this.hotel_id);
			this.exit_edit_mode();
		},
		onChangeHotel_pop_up(hotel) {
			this.hoteis_to_copy = hotel;
		},
		create_new_menu() {
			if(this.hotel_id == '') {
				this.$vs.notify({
					time: 4000,
					text: this.$t('O_campo_Hotel_é_obrigatório'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});
				
				return false;
			}

			this.create_new = true;

			if(this.update) {
				this.menu = '';
				this.type_selected = '';
				this.update = false;
			}
		},

		enter_edit_mode(menu) {
			this.menu = menu;
			this.type_selected = menu.type;
			this.update = true;
		},

		exit_edit_mode() {
			this.getMenusWihtLanguages(this.hotel_id);
			this.menu = '';
			this.type_selected = '';
			this.update = false;
			this.create_new = false;
		},
	 
		getWarehouses(hotel_id) {
			this.$vs.loading();

			let token = localStorage.getItem('usertoken');
			
			this.$api({
				method: 'get',
		 		url: '/myvilagale/hotel/' + hotel_id + '/warehouses',
				params: {
					token: token,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then((res) => {
				this.warehouses = res.data['warehouses'];
				this.$vs.loading.close();
			})
			.catch((err) => {
				this.$vs.loading.close();
			});
	 	},

	 	deleteEvent(varData){

            this.$vs.loading();
            this.$api.post( '/myvilagale/cards/cardDelete?token=' + this.$user.usertoken,
            {
                id: varData[0].id
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.$user.usertoken
                }
            })
            .then((res) => {
                this.notify(varData[1].charAt(0).toUpperCase() + varData[1].slice(1)+' eliminad'+varData[2]+' com sucesso.', 'green');
                this.onChangeHotel(this.hotel_id);
            })
            .catch((err) => {
                this.notify(err.response.data.message, 'red', 10);
                this.$vs.loading.close();
            });
        },
        openDialog(m, type){
        	type = type == 'marcação' ? 'carta' : type;
        	let letra = type == 'carta' ? 'a' : 'o';

            this.$vs.dialog({
                type: 'confirm',
                color: 'primary',
                title: this.$t('Deseja_mesmo_apagar'),
                text: this.$t('Pretende_eliminar')+' '+letra+' '+type+' "'+m.idiomas[0].name+'"?',
                acceptText: this.$t('yes'),
                cancelText: this.$t('no'),
                accept: this.deleteEvent,
                parameters: [m, type, letra]
            });
        },
        getHotels(){
        	let that = this;
			this.$api({
				method: 'get',
				url: '/myvilagale/get_hotels',
				params: {
					token: this.$user.usertoken,
					extra_hotels: [0]
				}
			})
			.then(function (res) {
				that.hotel_list = res.data;
				for (let i = 0; i < that.hotel_list.length; i++) {
					if(that.hotel_list[i]['id'] == that.hotel_id){
						that.hotel_list.splice(i, 1);
					}
				}
			})
			.catch ( function (err) {
				that.notify(that.$t('Erro_a_obter_hoteis'), "red");
			})
        }

  	},
  	computed: {
  		cartas_grouped_by_type: function() {
  			let grouped = {};
  			for(let m of this.menus) {
  				if(typeof grouped[m.type] === 'undefined') {
  					grouped[m.type] = [];
  				}
  				grouped[m.type].push(m);
  			}
  			return grouped;
  		}
  	},
	created() {

		if (this.user !== null && this.user.role == 4) {
			this.hotel_id = this.user.staff_info.hvg_id;
			this.getWarehouses(this.hotel_id);
			this.getMenusWihtLanguages(this.hotel_id);
		}else{
			/*if (this.user.hotel.hotel_id) {
	            this.hotel_id = this.user.hotel.hotel_id;
	            this.getWarehouses(this.hotel_id);
				this.getMenusWihtLanguages(this.hotel_id);
	        }*/
	    }
	},
	watch: {
		copy_pop_up: function(new_val, old_val) {
			if(!new_val) {
				this.hoteis_to_copy = [];
				this.langs = {
	                PT: [],
	                BR: [],
	                EN: [],
	                FR: [],
	                DE: [],
	                ES: []
	            }
			}
		},
	},
  	components: {
		HotelDropdown,
		CartaForm,
		MenuForm,
		MarcacaoForm,
		DirectorioForm
  	}
}
</script>

<style>
	
	.main_element_title {
		margin-top: 25px;
	}

	.hotel_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.type_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.dropdown_label {
		color: #4A4E4F;
		margin-top: 9px;
		margin-right: 15px;
	}

	.dropdown_label_description {
		margin-top: 25px;
	}

	.input_information {
		width: 75%;
	}

	.information_block {
		display: flex;
	}

	.dropdown_label_information {
		margin-top: 25px;
	}

	.dropdown_label_name {
		margin-top: 25px;
	}

	.price_block {
		display: flex;
	}

	.label_price {
		margin-top: 25px;
	}

	.moeda_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.main_element_title {
		color: #4A4E4F;
	}

	.visibility_block {
		margin-top: 25px;
	}

	.visibility li {
		width: 16.66%;
		text-align: center;
		color: #63C0BB;
		display: inline-block;
	}

	.add-files-comp {
		background: #f5f5f5;
		width: 200px;
		height: 200px;
		box-sizing: border-box;
		border-radius: 8px;
		position: relative;
		transition: all .25s ease;
		border: 1px dashed rgba(0,0,0,.1);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		margin: 5px;
	}

	.add-files-comp .text-input {
		min-width: 200px;
		display: block;
		text-align: center;
		margin: 0!important;
		padding: 0!important;
		width: 100%;
		font-weight: 700;
	}

	div.file-listing{
		width: 400px;
	}

	span.remove-file{
		color: red;
		cursor: pointer;
		float: right;
	}

	.con-img-upload {
		width: 100%;
		background: #fff;
		margin-top: 5px;
		padding-right: 5px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		-webkit-column-gap: 5px;
		-moz-column-gap: 5px;
		column-gap: 5px;
	}

	.mainCartas .vs-list--item .vs-list--slot{
		display: flex;
	}

	.copy_pop_up .vs-popup .vs-popup--content{
		position: relative;
		height: 100% !important;
	}

</style>

